import React from "react";
import { CaretLeft, MapTrifold, Sparkle } from "@phosphor-icons/react";
import { SuitcasesIllustration } from "./illustrations";

/**
 * Trips tab — placeholder for v1.2.
 *
 * The "My Trips" CTA on Home + the "Add a trip" action on the Saved tab
 * both navigate here. The full feature (named trips, offline language
 * packs, per-trip phrasebook, saved currency rates, country tipping
 * cheat sheet) ships in v1.2. For now, this gives users a polished
 * page instead of a blank screen.
 */
export default function TripsTab({ onBack }) {
  const features = [
    { title: "Name your trip", body: "“Paris 2026”, “Tokyo honeymoon”, “Tulum getaway” — keep every trip organised." },
    { title: "Offline phrasebook + tipping guide", body: "Saved per trip so you’re covered on the plane and underground." },
    { title: "Live rates, frozen", body: "Pin today’s exchange rate so you never get gouged at a sketchy currency desk." },
    { title: "All your saved tips, filtered", body: "Auto-grouped by trip so settling up at the end of the trip is one tap." },
  ];

  return (
    <div className="px-5 pt-4 pb-2" data-testid="trips-screen">
      <div className="flex items-center justify-between mb-5">
        <button
          type="button"
          onClick={() => onBack?.()}
          data-testid="trips-back"
          aria-label="Back"
          className="w-10 h-10 rounded-full bg-white shadow-soft border border-navy/10 flex items-center justify-center"
        >
          <CaretLeft size={20} weight="bold" color="#0E2C54" />
        </button>
        <h2 className="font-jakarta font-extrabold text-navy text-xl">
          My Trips
        </h2>
        <div className="w-10 h-10" />
      </div>

      {/* Hero */}
      <div className="bg-orange-soft border border-orange/15 rounded-2xl p-5 flex flex-col items-center text-center">
        <div className="w-28 h-28">
          <SuitcasesIllustration className="w-full h-full" />
        </div>
        <div className="mt-2 flex items-center gap-1.5 bg-white/70 backdrop-blur rounded-full px-3 py-1">
          <Sparkle size={12} weight="fill" color="#E55B2C" />
          <span className="font-jakarta font-extrabold text-orange text-[11px] uppercase tracking-wider">
            Coming in v1.2
          </span>
        </div>
        <h3 className="mt-3 font-jakarta font-extrabold text-navy text-2xl leading-tight">
          Save & organise every trip
        </h3>
        <p className="mt-2 text-navy-soft text-sm font-jakarta font-medium leading-relaxed max-w-[28ch]">
          We’re building a dedicated trips workspace so your tipping rules,
          phrases, and rates travel with you — even offline.
        </p>
      </div>

      {/* What's coming */}
      <div className="mt-5 bg-white rounded-2xl shadow-soft border border-navy/5 overflow-hidden">
        {features.map((f, i) => (
          <div
            key={f.title}
            className={`px-4 py-3.5 flex items-start gap-3 ${
              i < features.length - 1 ? "border-b border-navy/5" : ""
            }`}
          >
            <div className="shrink-0 mt-0.5 w-9 h-9 rounded-full bg-orange-soft flex items-center justify-center">
              <MapTrifold size={18} weight="duotone" color="#E55B2C" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="font-jakarta font-extrabold text-navy text-base leading-snug">
                {f.title}
              </div>
              <div className="text-navy-soft text-sm font-jakarta font-medium mt-0.5 leading-relaxed">
                {f.body}
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        type="button"
        onClick={() => onBack?.()}
        data-testid="trips-cta-back"
        className="w-full mt-5 bg-navy text-white font-jakarta font-extrabold text-base rounded-full py-3.5 shadow-soft"
      >
        Back to TipLingo
      </button>

      <p className="mt-3 text-center text-navy-soft text-xs font-jakarta font-medium">
        Want this sooner? Tell us in Settings → Help & feedback.
      </p>
    </div>
  );
}
